module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KqQR9/tc-custom/cover.jpeg?1663929390583?1704424599662",
      "alt": "This image is the cover for the book Triplanetary, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Triplanetary, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From the atomic age in Atlantis to a world remote in space and time, two incredible ancient races, the Arisians and the Eddorians, are in the midst of an interstellar war with Earth as the prize. The Arisians, using advanced mental technology, have foreseen the invasion of their galaxy by the corrupt and evil Eddorians, so they begin a breeding program on every planet in their universe. Their goal...to produce super warriors who can hold off the invading Eddorians. (Goodreads)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      E. E. Smith\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Edward Elmer Smith (May 2, 1890 – August 31, 1965), publishing as E. E. Smith, Ph.D. and later as E. E. \"Doc\" Smith, was an American food engineer (specializing in doughnut and pastry mixes) and science-fiction author, best known for the Lensman and Skylark series. He is sometimes called the father of space opera.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0